((global,factory) => {
  global.skin = factory;
  factory(global);
})(window || this,() => {
      let link = document.createElement('link');
      let defaultSkin='default';
      let skin = localStorage.getItem('skin') || defaultSkin;
      let removeSkin = skin == 'default'?'green':'default';
      window.skinColor = skin == 'default'?'#0896D7':'#FF5050';
      window.skinStarColor = skin == 'default'?'#000000':"#DB0001";
      document.getElementById(removeSkin) && document.documentElement.removeChild(document.getElementById(removeSkin));
      link.rel = 'stylesheet';
      link.id = skin;
      link.href = `../../../static/lib/css/default/theme.css`;
      document.documentElement.appendChild(link);
})